import React from 'react';
import Stack from '@mui/material/Stack';
import ViewCarouselOutlinedIcon from '@mui/icons-material/ViewCarouselOutlined';
import FolderOpenOutlinedIcon from '@mui/icons-material/FolderOpenOutlined';

import { IconButtonRounded } from '../../components';
import { FolderManagerViewTypes } from '../../interfaces';
import layoutBoardIcon from '../../../assets/icons/layout-grid.svg';
import layoutListIcon from '../../../assets/icons/layout-list.svg';

/**
 * @param {{
 *   activeView: ViewType,
 *   onChange: (view: ViewType) => void,
 *   availableViews?: (FolderManagerViewTypes.SLIDES | FolderManagerViewTypes.GRID | FolderManagerViewTypes.LIST | FolderManagerViewTypes.FOLDERS)[];
 * }} props
 */
const ViewTypeSwitcher = ({ activeView, onChange, availableViews }) => {
  const showSlidesView = availableViews?.includes(FolderManagerViewTypes.SLIDES);
  const showFoldersView = availableViews?.includes(FolderManagerViewTypes.FOLDERS);
  const showGridView = !availableViews || availableViews.includes(FolderManagerViewTypes.GRID);
  const showListView = !availableViews || availableViews.includes(FolderManagerViewTypes.LIST);

  if (!availableViews || availableViews.length <= 1) {
    return null;
  }

  return (
    <Stack
      spacing={1}
      direction="row"
      sx={{
        alignItems: 'center',
        ml: 'auto',
      }}
    >
      {showFoldersView && (
        <IconButtonRounded
          active={activeView === FolderManagerViewTypes.FOLDERS}
          title="Folders"
          icon={<FolderOpenOutlinedIcon sx={{ width: 14, height: 14 }} />}
          onClick={() => onChange(FolderManagerViewTypes.FOLDERS)}
          materialIcon
        />
      )}
      {showSlidesView && (
        <IconButtonRounded
          active={activeView === FolderManagerViewTypes.SLIDES}
          title="Slides"
          icon={<ViewCarouselOutlinedIcon sx={{ width: 14, height: 14 }} />}
          onClick={() => onChange(FolderManagerViewTypes.SLIDES)}
          materialIcon
        />
      )}
      {showGridView && (
        <IconButtonRounded
          active={activeView === FolderManagerViewTypes.GRID}
          title="Thumbnail"
          icon={<img src={layoutBoardIcon} alt="Thumbnail view" />}
          onClick={() => onChange(FolderManagerViewTypes.GRID)}
        />
      )}
      {showListView && (
        <IconButtonRounded
          active={activeView === FolderManagerViewTypes.LIST}
          title="List"
          icon={<img src={layoutListIcon} alt="List view" />}
          onClick={() => onChange(FolderManagerViewTypes.LIST)}
        />
      )}
    </Stack>
  );
};

export default ViewTypeSwitcher;
